var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
$CLJS.OA=require("ttag");module.exports=$CLJS.OA;